import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["label"];

  disablePulse() {
    for (let el of this.labelTargets) {
      if (!el.classList.contains('animate-none')) {
        el.classList.add('animate-none');
      }
    }
  }

  poolNotification(event) {
    var teamId = event.currentTarget.dataset.teamId;
    var teamEl = document.getElementById(`team_content_${teamId}`);
    var unavailable = document.getElementById(`unavailable_${teamId}`);
    var label = document.getElementById(`team_id_${teamId}`);
    var teamArea = document.getElementById(`team-area-${teamId}`);

    if (label.disabled && teamArea.classList.contains('unavailable')) {
      teamEl.classList.toggle('hidden');
      unavailable.classList.toggle('hidden');

      window.setTimeout(function () {
        teamEl.classList.toggle('hidden');
        unavailable.classList.toggle('hidden');
      }, 5000)
    }
  }
}